module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-inverse",
    class: ("card-" + _vm.bg)
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "h1 text-muted text-xs-right m-b-2 pull-right"
  }, [_vm._t("percents"), _vm._v(" "), (_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: ("fa-" + _vm.icon)
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "h4 m-b-0"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('small', {
    staticClass: "text-muted text-uppercase font-weight-bold"
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cf45d08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashCard.vue
// module id = 589
// module chunks = 0